import { memo } from 'react';
import Box from '@mui/material/Box';
import FormControl from '@mui/material/FormControl';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material/styles';
import { RECENCY_OPTIONS } from './constants';

/**
 * RecencyFilter - A single recency filter dropdown
 */
const RecencyFilter = memo(({ label, id, name, value, onChange }) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: 'flex',
        gap: 1,
        px: 0.75,
        py: 0.5,
        border: '1px solid #e0e0e0',
        borderRadius: 1,
        background: theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.05)' : '#fafafa',
        alignItems: 'center',
        height: 34,
      }}
    >
    <Typography
      variant='caption'
      sx={{ fontSize: 10, fontWeight: 600, letterSpacing: 0.5, mr: 0.5 }}
    >
      {label}
    </Typography>
    <FormControl
      size='small'
      sx={{
        minWidth: 70,
        '& .MuiOutlinedInput-root': { height: 28 },
        '& .MuiSelect-select': { py: 0.5, fontSize: 12 },
      }}
    >
      <Select
        id={id}
        name={name}
        value={value ?? ''}
        onChange={e => onChange(e.target.value === '' ? null : Number(e.target.value))}
        displayEmpty
        MenuProps={{ PaperProps: { sx: { maxHeight: 300 } } }}
      >
        {RECENCY_OPTIONS.map(o => (
          <MenuItem key={String(o.value)} value={o.value === null ? '' : o.value}>
            {o.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
    </Box>
  );
});

RecencyFilter.displayName = 'RecencyFilter';

/**
 * RecencyFilters - Renders the Updated/Engaged/Created filter dropdowns
 */
const RecencyFilters = memo(({
  lastUpdatedDays,
  lastEngagedDays,
  lastCreatedDays,
  onLastUpdatedChange,
  onLastEngagedChange,
  onLastCreatedChange,
}) => (
  <>
    <RecencyFilter
      label="Updated"
      id="last-updated-days-select"
      name="lastUpdatedDays"
      value={lastUpdatedDays}
      onChange={onLastUpdatedChange}
    />
    <RecencyFilter
      label="Engaged"
      id="last-engaged-days-select"
      name="lastEngagedDays"
      value={lastEngagedDays}
      onChange={onLastEngagedChange}
    />
    <RecencyFilter
      label="Created"
      id="last-created-days-select"
      name="lastCreatedDays"
      value={lastCreatedDays}
      onChange={onLastCreatedChange}
    />
  </>
));

RecencyFilters.displayName = 'RecencyFilters';

export default RecencyFilters;
